module.exports = __webpack_public_path__ + "static/media/item_2_2.3fc821f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_2.png
// module id = 109
// module chunks = 0